import { useEffect, useRef } from 'react'

const useInterval = (callback: () => any, delayInMilliseconds: number | null): any => {
    const savedCallback = useRef(callback)

    // Remember the latest callback if it changes.
    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    // Set up the interval.
    useEffect(() => {
        // Don't schedule if no delay is specified.
        if (delayInMilliseconds === null) {
            return
        }

        const id = setInterval(() => savedCallback.current(), delayInMilliseconds)

        // eslint-disable-next-line consistent-return
        return () => clearInterval(id)
    }, [delayInMilliseconds])
}

export { useInterval }

// USAGE:
/*  useInterval(
 *    () => {
 *      // Your custom logic here
 *      setCount(count + 1)
 *    },
 *    // Delay in milliseconds or null to stop it
 *    isPlaying ? delay : null,
 *  )
 */
